module.exports = __webpack_public_path__ + "static/img/zfj.57baee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/zfj.jpg
// module id = SLm9
// module chunks = 0